import { useContext } from "react";
import BackendContext from "../context/backend_provider";
import { getLoginStatus } from "../pages/login/login_utils";

export default function useBackend() {
  return useContext(BackendContext);
}

export function useLoginStatus() {
  const login = useLogin();
  return getLoginStatus(login);
}

export function useLogin() {
  const { login } = useBackend();
  return login;
}

export function useFormattedPrivileges() {
  const { login } = useBackend();
  if (login && login.privileges) {
    const componentsMap = new Map();
    login.privileges.forEach((priv) => {
      if (!componentsMap.has(priv.feature)) {
        componentsMap.set(priv.feature, []);
      }
      componentsMap.get(priv.feature).push({
        component: priv.component,
        permissions: priv.permission_list,
      });
    });
    return componentsMap;
  }
}

export function useUserPrivilegeKeyPermissionsMap() {
  const componentsMap = new Map();
  const { login } = useBackend();
  if (login && login.privileges) {
    login.privileges.forEach((priv) => {
      componentsMap.set(`${priv.feature}_${priv.component}`, priv.permission_list);
    });
  }
  return componentsMap;
}

export function useAllowedComponents() {
  const { login } = useBackend();
  return login && login.privileges
    ? [...new Set(login.privileges.map((privilege) => `${privilege.feature}_${privilege.component}`))]
    : [];
}

export function useAllowedFeatures() {
  const { login } = useBackend();
  return login && login.privileges ? [...new Set(login.privileges.map((privilege) => privilege.feature))] : [];
}

export function useSetLogin() {
  const { setLogin } = useBackend();
  return setLogin;
}
